import { ProductManagement } from 'routes/course'

export default ProductManagement
